import {i18n} from '@lingui/core';
import {t} from '@lingui/macro';

const unknownError = i18n._(t('previewer-dryrun-error-unknown')`Error while evaluating variables.`);

const codeErrors: Record<string, string> = {
  convert_failed: i18n._(t('previewer-dryrun-error-invalidurl')`Not a valid URL.`),
  unsafe_url: i18n._(t('previewer-dryrun-error-unsafeurl')`Must be a HTTP or HTTPS public URL.`),
};

export function parsePreviewerDryRunError(err: any) {
  const {body} = err;
  if (!err || !body) {
    return unknownError;
  }

  const codeError = codeErrors[body.code];
  if (codeError) {
    return codeError;
  }

  return unknownError;
}
